import azure from '../azure';
import { PublicClientApplication } from '@azure/msal-browser';
import { authService } from '../services/AuthService';

export const msalConfig = {
  auth: {
    clientId: azure.appId,
    authority: azure.ssoURL,
    redirectUri: azure.redirectUri,
    postLogoutRedirectUri: azure.redirectUri + "/#/login",
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: azure.scopes,
  prompt: 'login',
};

export const initMsalInstance = async () => {
  const instance = new PublicClientApplication(msalConfig);
  await instance.initialize();
  authService.setMsalInstance(instance);
  return instance;
};

export const getMsalInstance = () => authService.getMsalInstance();

